import React from 'react';
import classNames from 'classnames';
import './index.scss';

const RadioButton = ({value, onChange, title}) => {

    return (
        <label className={classNames("RadioButton")}>
            <input 
                type="radio" 
                value={value} 
                checked={value} 
                onChange={() => onChange(!value)}
            />
            {title && <span className={classNames("title")}>{title}</span>}
        </label>
    )
}

export default RadioButton